import type { FloorplanZone, FloorplanZoneDisplayDefaults, FloorplanZoneOutlineShape } from '../types';

export const DEFAULT_ZONE_DISPLAY: Required<FloorplanZoneDisplayDefaults> = {
  strokeWidth: 0.2,
  selectedStrokeWidth: 0.32,
  shape: 'rounded',
  fillOpacity: 0.08,
};

export function resolveZoneOutlineShape(
  zone: FloorplanZone,
  defaults: FloorplanZoneDisplayDefaults = {},
): FloorplanZoneOutlineShape {
  return zone.outlineShape ?? defaults.shape ?? DEFAULT_ZONE_DISPLAY.shape;
}

export function resolveZoneStrokeWidth(
  zone: FloorplanZone,
  isSelected: boolean,
  defaults: FloorplanZoneDisplayDefaults = {},
): number {
  if (zone.outlineStrokeWidth != null) {
    return zone.outlineStrokeWidth;
  }
  if (isSelected) {
    return defaults.selectedStrokeWidth ?? DEFAULT_ZONE_DISPLAY.selectedStrokeWidth;
  }
  return defaults.strokeWidth ?? DEFAULT_ZONE_DISPLAY.strokeWidth;
}

export function resolveZoneFillOpacity(defaults: FloorplanZoneDisplayDefaults = {}): number {
  return defaults.fillOpacity ?? DEFAULT_ZONE_DISPLAY.fillOpacity;
}
